import "./sidebar.scss"
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import SummarizeIcon from '@mui/icons-material/Summarize';
import SchoolIcon from '@mui/icons-material/School';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import CampaignIcon from '@mui/icons-material/Campaign';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import CommentIcon from '@mui/icons-material/Comment';
import LogoutIcon from '@mui/icons-material/Logout';
import AttachmentIcon from '@mui/icons-material/Attachment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GroupsIcon from '@mui/icons-material/Groups';
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthProvider';
import { removeTokens } from '../../api/auth';
import { GradeOutlined } from "@mui/icons-material";

export const Sidebar = () => {
  const navigate = useNavigate();
  const { setIsAuthenticated } = useAuth();
  const activeRole = localStorage.getItem("activeRole"); // <-- only use the chosen role

  const handleLogout = () => {
    removeTokens(); 
    setIsAuthenticated(false);
    localStorage.removeItem("activeRole");
    navigate('/login');
  };

  return (
    <div className="sidebar">
      <div className="top">
        <Link to="/" style={{ textDecoration: "none" }}>
          <span className="logo">Thesis Management</span>
        </Link>
      </div>
      <hr />
      <div className="center">
        {activeRole === "ROLE_ADMIN" && (
          <ul>
            <p className="title">MAIN</p>
            <Link to="/" style={{ textDecoration: "none" }}>
              <li>
                <DashboardIcon className="icon" />
                <span>Dashboard</span>
              </li>
            </Link>
            <p className="title">LISTS</p>
            <Link to="/students" style={{ textDecoration: "none" }}>
              <li>
                <PersonOutlineIcon className="icon" />
                <span>Students</span>
              </li>
            </Link>
            <Link to="/instructors" style={{ textDecoration: "none" }}>
              <li>
                <SupervisorAccountIcon className="icon" />
                <span>Instructors</span>
              </li>
            </Link>
            <Link to="/thesis" style={{ textDecoration: "none" }}>
              <li>
                <SummarizeIcon className="icon" />
                <span>Thesis</span>
              </li>
            </Link>
            <Link to="/terms" style={{ textDecoration: "none" }}>
              <li>
                <AccessTimeIcon className="icon" />
                <span>Terms</span>
              </li>
            </Link>
            <Link to="/announcements" style={{ textDecoration: "none" }}>
              <li>
                <CampaignIcon className="icon" />
                <span>Announcements</span>
              </li>
            </Link>
            <p className="title">SERVICE</p>
            <Link to="/assignterms" style={{ textDecoration: "none" }}>
              <li>
                <ManageAccountsIcon className="icon" />
                <span>Assign Student Terms</span>
              </li>
            </Link>
            <Link to="/assignexaminers" style={{ textDecoration: "none" }}>
              <li>
                <AssignmentIndIcon className="icon" />
                <span>Assign Examiners</span>
              </li>
            </Link>
            <Link to="/studentrequests" style={{ textDecoration: "none" }}>
              <li>
                <QuestionAnswerIcon className="icon" />
                <span>Student Requests</span>
              </li>
            </Link>
            <Link to="/feedbacks" style={{ textDecoration: "none" }}>
              <li>
                <CommentIcon className="icon" />
                <span>Thesis Feedback</span>
              </li>
            </Link>
            <Link to="/grades" style={{ textDecoration: "none" }}>
              <li>
                <GradeOutlined className="icon" />
                <span>Student Grades</span>
              </li>
            </Link>
            <li>
              <GroupsIcon className="icon" />
              <span>Panel Creation</span>
            </li>
            <Link to="/lecturelinks" style={{ textDecoration: "none"}}>
              <li>
                <AttachmentIcon className="icon" />
                <span>Lecture Links</span>
              </li>
            </Link>
            <li onClick={handleLogout}>
              <LogoutIcon className="icon" />
              <span>Logout</span>
            </li>
          </ul>
        )}

        {activeRole === "ROLE_EXAMINER" || activeRole === "ROLE_REVIEWER" ? (
          <ul>
            <p className="title">LISTS</p>
            <Link to="/examiner" style={{ textDecoration: "none" }}>
              <li>
                <SummarizeIcon className="icon" />
                <span>Thesis Assigned</span>
              </li>
            </Link>
            <Link to="/feedbacks" style={{ textDecoration: "none" }}>
              <li>
                <CommentIcon className="icon" />
                <span>Thesis Feedbacks</span>
              </li>
            </Link>
            <p className="title">SERVICE</p>
            <li onClick={handleLogout}>
              <LogoutIcon className="icon" />
              <span>Logout</span>
            </li>
          </ul>
        ) : null}

        {activeRole === "ROLE_STUDENT" && (
          <ul>
            <p className="title">MAIN</p>
            <Link to="/student" style={{ textDecoration: "none" }}>
              <li>
                <SummarizeIcon className="icon" />
                <span>My Submissions</span>
              </li>
            </Link>
            <Link to="/student/feedbacks" style={{ textDecoration: "none" }}>
              <li>
                <CommentIcon className="icon" />
                <span>Received Feedbacks</span>
              </li>
            </Link>
         { /*  <Link to="/student/monthly-evaluation" style={{ textDecoration: "none" }}>
              <li>
                <AssessmentIcon className="icon" />
                <span>Monthly Evaluations</span>
              </li>
            </Link> */}
            <Link to="/student/resources" style={{ textDecoration: "none" }}>
              <li>
                <AssessmentIcon className="icon" />
                <span>Resources</span>
              </li>
            </Link>
            <p className="title">SERVICE</p>
            <li onClick={handleLogout}>
              <LogoutIcon className="icon" />
              <span>Logout</span>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};
